import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header';
import Hero from './Hero';
import Skills from './Skills';
import Projects from './Projects';
import Certifications from './Certifications';
import About from './About';
import Contact from './Contact';
import Footer from './Footer';
import { mockData } from '../data/mock';

const Portfolio = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="text-green-400 text-xl font-mono"
        >
          <div className="flex items-center space-x-2">
            <div className="w-4 h-4 bg-green-400 rounded-full animate-pulse"></div>
            <span>Loading KatifSec Portfolio...</span>
          </div>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black text-white">
      <Header />
      <main>
        <Hero data={mockData.personal} />
        <Skills data={mockData.skills} />
        <Projects data={mockData.projects} />
        <Certifications data={mockData.certifications} />
        <About data={mockData.about} />
        <Contact data={mockData.contact} />
      </main>
      <Footer />
    </div>
  );
};

export default Portfolio;